export enum AnswerOptionType {
  No = 'No',
  Yes = 'Yes',
  Neutral = 'Neutral',
  Multiple = 'Multiple',
}

export enum QuestionType {
  SingleSelectYesNoQuestion = 'SingleSelectYesNoQuestion',
  SingleSelectYesNeutralNoQuestion = 'SingleSelectYesNeutralNoQuestion',
  MultipleSelect = 'MultipleSelect',
}
export interface AnswerOption {
  id?: string;
  tag?: string;
  order?: number;
  type?: AnswerOptionType;
}

export interface BaseQuestion {
  id: string;
  type: QuestionType;
  tag: string;
  hasInfo: boolean;
  order?: number;
  options: AnswerOption[];
  defaultSelection: string[];
}

export interface QuestionOption {
  id: string;
  tag: string;
  order: number;
  type: string;
}

export interface ProductAttrribute {
  tag?: string;
  value?: string | number;
  order?: number;
}
export interface Product {
  productId?: string;
  productAttributes?: ProductAttrribute[];
  productStatus?: string;
}

export interface ProductApiResponse {
  products: Product[];
  totalCount: number;
}

export type FormState = Record<string, string | string[]>;
